import { render, staticRenderFns } from "./aiSearchCollapseInfo.vue?vue&type=template&id=af122d7a&scoped=true"
import script from "./aiSearchCollapseInfo.vue?vue&type=script&lang=js"
export * from "./aiSearchCollapseInfo.vue?vue&type=script&lang=js"
import style0 from "./aiSearchCollapseInfo.vue?vue&type=style&index=0&id=af122d7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af122d7a",
  null
  
)

export default component.exports